import { Box } from "@mui/material";
import services from "../../../../../data/services.json";
import ServicesHelmet from "../../../../../Helmets/ServicesHelmet";
import MobileService from "./MobileService";

export default function MobileServicesPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        mt: 4,
        mb: 6,
      }}
    >
      <ServicesHelmet />
      {services.services.map((service) => (
        <MobileService key={service.title} service={service} />
      ))}
    </Box>
  );
}
